export function viewFile(url: string) {
  window.open(url, '_blank');
}